// removed by extract-text-webpack-plugin
module.exports = {"propertyRow":"UBu20pQJRqitXY3d-UmvV","similarProperty":"_1pu2dGu46y6I-d5J5R8MCH","propertyDescription":"YrF_XJYUH1rj1kV091cWK","iconsWrapper":"_3zY90z602KoQVEJCfkrbGk","labelNew":"_32EDbjmGTIsXaIknIKIXTo","propertyType":"_3EiJlNpj97ocB0vd6eF_2Q","propertyAddress":"_1-HbVU3gyXIe16OV9Stfom","address":"RcdTIZEXV05BBO6Yj-aeh","neighborhood":"_1OhZOzdWmHXYX4e0Btqxiw","noteIconWrapper":"_2SfYXY2Ji5csSQ2v4tLL_P","noteIcon":"_2WYwgo5x7i20XLt1eg5crb","noteTooltip":"_4crukGI9wnp4iW5jYLwV0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMPropertyCells/OMBaseVerticalPropertyCell/OMHomePageSliderCell.scss
// module id = 1662
// module chunks = 0